module.exports = __webpack_public_path__ + "static/media/picture-(242).6bc97c20.JPG";